import React, { useEffect, useState } from 'react';
import { Table, Input, InputNumber, Popconfirm, Form, Button, Row, Col  } from 'antd';
import { DeleteOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';

// const originData: any[] = [];
// for (let i = 0; i < 100; i++) {
//     originData.push({
//         key: i.toString(),
//         nameconst: `Edrward ${i}`,
//     });
// }
interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
    editing: boolean;
    dataIndex: string;
    title: any;
    inputType: 'number' | 'text';
    record: any;
    index: number;
    children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber autoComplete="off" /> : <Input autoComplete="off" />;

    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[
                        {
                            required: true, whitespace: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                    children
                )}
        </td>
    );
};

const CommonEditableTable = ({ tableRowdata, columns, onDelete, onSave, customFormData }: any) => {
    const [form] = Form.useForm();
    const [data, setData] = useState(tableRowdata);
    const [editingKey, setEditingKey] = useState('');

    useEffect(() => {
        setData([...tableRowdata]);
        cancel();
    }, [tableRowdata]);
    const isEditing = (record: any) => record.key === editingKey;
    const edit = (record: any) => {
        form.setFieldsValue({ ...customFormData, ...record });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const deleteFunc = (record: any) => {
        onDelete(record);
    };

    const tableConfig = {
        loading: false,
        pagination: {
          position: 'bottomRight',
          current: 1,
          pageSize: 10
        },
        showHeader: true,
        tableLayout: undefined,
        // sortDirections: ['ascend' , 'descend','ascend' ]
      };

    const save = async (key: React.Key) => {
        try {
            const row = (await form.validateFields()) as any;

            // const newData = [...data];
            const index = data.findIndex(item => key === item.key);

            if (index > -1) {
                const item = data[index];
                onSave({
                    ...row,
                    key: item.key
                });
                // newData.splice(index, 1, {
                //     ...item,
                //     ...row,
                // });
                // setData(newData);
                // setEditingKey('');
            } else {
                // newData.push(row);
                // setData(newData);
                setEditingKey('');
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const extracolumns = [
        {
            title: 'Edit',
            dataIndex: 'Edit',
            width: '20%',
            render: (_: any, record: any) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Button onClick={() => save(record.key)} style={{ marginRight: 8 }} type="primary" ghost>
                            <SaveOutlined />Save
                        </Button>
                        <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                            <Button >Cancel</Button>
                        </Popconfirm>
                    </span>
                ) : (
                        <Button type="primary" ghost aria-disabled={editingKey !== ''} onClick={() => edit(record)}>
                            <EditOutlined /> Edit
                        </Button>
                    );
            },
        },
        {
            title: 'Delete',
            dataIndex: 'Delete',
            width: '20%',
            render: (_: any, record: any) => {
                return (
                    <Popconfirm title="Sure to cancel?" onConfirm={() => deleteFunc(record)}>
                        <Button danger>
                            <DeleteOutlined />Delete
                        </Button>
                    </Popconfirm>
                );
            },
        }
    ];
    let columnsData = [];
    columnsData = [...columns, ...extracolumns]
    const mergedColumns = columnsData.map(col => {
        if (!col?.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: any) => ({
                record,
                inputType: col.dataIndex === 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    const handleTableChange = (pagination: any, filters: any, sorter: any) => {
        if (sorter.column && sorter.column.sorter) {
            if (sorter.order === 'ascend') {
                console.log(data, sorter,  'data');
                data.sort(function (a: any, b: any) {
                    return a[sorter.field].localeCompare(b[sorter.field]);
                });
            } else {
                data.reverse();
            }
        } else {
            if (!sorter.column) {
                setData([...tableRowdata]);
            }
        }
    }

    const handleSearchChange = ({ target: { value } }) => {
        setData(tableRowdata.filter(eachRowData => {
                for (let key in eachRowData) {
                    if (key !== 'key' && eachRowData[key].includes(value)) {
                        return eachRowData;
                    }
                }
                return eachRowData;
            }
        ))
    }

    return (
        <Form form={form} component={false}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" span={24}>
                    <Input autoComplete="off" className="search_bar" onChange={e => handleSearchChange(e)} placeholder="Search" />
                </Col>
            </Row>
            <Table
                {...tableConfig}
                components={{
                    body: {
                        cell: EditableCell,
                    },
                }}
                bordered
                dataSource={data}
                columns={mergedColumns}
                rowClassName="editable-row"
                pagination={{ position: ['bottomRight'], pageSize: 10 }}
                scroll={{ x: 300 }}
                onChange={handleTableChange}
            />
        </Form>
    );
};

export default CommonEditableTable;